import React from 'react';
import Box from '@nubank/nuds-web/components/Box/Box';

import FooterNavigation from './FooterNavigation/FooterNavigation';
import FooterBottom from './FooterBottom/FooterBottom';

function FooterContractPages() {
  return (
    <Box
      tag="footer"
      padding={{ xs: '8x', lg: '12x' }}
      backgroundColor="black.default"
      color="white.default"
    >
      <FooterNavigation />
      <FooterBottom />
    </Box>
  );
}

export default FooterContractPages;
